import { createGlobalStyle } from 'styled-components';

const GlobalScrollStyles = createGlobalStyle`
  * {
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
  }

  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  *::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-radius: 4px;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
    transition: background-color 0.2s ease;
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
`;

export default GlobalScrollStyles;